class PrintScreen {

  constructor() {
    this.printScreenButton();
    this.printSectionButton();
  };

  printSectionButton() {
    document.querySelectorAll('.btn.print-screen-cta.print-hidden').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        if (e.target === button) {

          let sectionId = button.dataset.printsection;

          document.querySelectorAll('.section.typography.cmp-rte').forEach((elem) => {
            if (elem.id != sectionId) {
              this.hideElements(elem)
            }

          });
          window.print();

          this.restoreElements('.section.typography.cmp-rte')
        }
      });
    });
  };

  printScreenButton() {
    document.querySelectorAll('.fa.fa-print').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        if (e.target === link) {

          let docId = link.dataset.printlink;
          document.querySelectorAll('.rate-table').forEach((elem) => {
            if (elem.id != docId) {
              this.hideElements(elem)
            }
          });
          window.print();
          this.restoreElements('.rate-table')
        }
      });
    });
  };


  hideElements(element) {
    element.classList.add('d-none')
  }

  restoreElements(selector) {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.classList.contains('d-none')) {
        element.classList.remove('d-none')
      }
    })
  }

}


document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.rate-table')) {
    const printScreen = new PrintScreen();
  }
})
